function getYoutubeVideoIDFromUrl(url: string): string | null {
  var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
  var match = url.match(regExp);
  return match && match[7].length == 11 ? match[7] : null;
}

export default function getYoutubeEmbedUrl(url: string): string {
  const id = getYoutubeVideoIDFromUrl(url);
  return `https://www.youtube.com/embed/${id}?autoplay=1&modestbranding=1&rel=0&showinfo=0`;
}
